import {supportActionTypes} from "../_constants";

export function support(state = {articles: {}}, action) {
  
  switch (action.type) {

    // get support section article request
    case supportActionTypes.GET_SECTION_ARTICLE_REQUEST:
      return {
        ...state,
        articles: {
          [action.section]: {
            isLoading: true,
            isLoaded: false,
            isFailed: false,
          }
        }
      }

    // get support section article success
    case supportActionTypes.GET_SECTION_ARTICLE_SUCCESS:
      return {
        ...state,
        articles: {
          [action.section]: {
            isLoading: false,
            isLoaded: true,
            isFailed: false,
            list: action.articles
          }
        }
      }

    // get support section article failure
    case supportActionTypes.GET_SECTION_ARTICLE_FAILURE:
      return {
        ...state,
        articles: {
          [action.section]: {
            isLoading: false,
            isLoaded: false,
            isFailed: true,
          }
        }
      }

    default:
      return state
  }
}